import { render, staticRenderFns } from "./ProductUpsellModal.vue?vue&type=template&id=7dde0580&scoped=true&"
import script from "./ProductUpsellModal.vue?vue&type=script&lang=js&"
export * from "./ProductUpsellModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpsellModal.vue?vue&type=style&index=0&id=7dde0580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dde0580",
  null
  
)

export default component.exports